import React from 'react';

import { Alert, Button, Stack, Text } from '@origin-digital/ods-core';

export interface IBelowThresholdAlert {
  label: string;
  onClick: () => void;
}

export const BelowThresholdAlert = ({ label, onClick }: IBelowThresholdAlert) => {
  return (
    <Alert tone="caution" title="Please confirm your address" data-id="nmi-below-threshold-alert">
      <Stack space="medium">
        <Text>
          We just need to double check we’re setting up the right meter. It’ll only take a second.
          You may want a recent electricity bill handy to help.
        </Text>
        <Button size="small" onClick={() => onClick()}>
          {label}
        </Button>
      </Stack>
    </Alert>
  );
};
